import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { gsap } from "gsap";

@Component({
  selector: 'app-country-map-hero',
  templateUrl: './hero-country-map.component.html',
  styleUrls: ['./hero-country-map.component.scss']
})
export class CountryMapHeroComponent implements OnInit {

  private router: Router;

  constructor(router: Router) { this.router = router }

  public ngOnInit(): void
  {
    this.animateHeader();
  }

  public showPage(): void
  {
    this.router.navigateByUrl('/lodder-til-salg/lodder');
  }
  public animateHeader(): void
  {
    gsap.registerEffect({
      name: "pulse",
      effect: (targets, config) => {
        tl = gsap.timeline({repeat: 3, repeatDelay: 0.3 });
        tl.to(targets, { scale: 1.2, duration: 0.3, ease: "back.in(4)" })
          .to(targets, { scale: 1, duration: 0.3, ease: "back.out(4)" });
        return tl
      },
      defaults: {duration: 0.5},
      extendTimeline: true
    });
    
    var tl = gsap.timeline({repeat: -1, repeatDelay: 10});
  
    tl.add("start");
    
    tl.pulse(".pulse", "+=3"); 
  }
}

